import { isValidBrainSimulation } from './BrainSimulation';
export const brainSimulationApiToBrainSimulationEntity = brainSimulation => {
  var _brainSimulation$task;
  if (!brainSimulation) {
    throw new Error('Invalid brain simulation', {
      cause: {
        brainSimulation
      }
    });
  }
  const convertedBrainSimulation = {
    id: brainSimulation.id ?? undefined,
    revision: brainSimulation.revision ?? undefined,
    createdDate: brainSimulation.createdDate,
    updatedDate: brainSimulation.updatedDate,
    name: brainSimulation.name,
    description: brainSimulation.description,
    initialNoteExamples: brainSimulation.initialNoteExamples,
    additionalNoteExamples: brainSimulation.additionalNoteExamples,
    simulationSize: brainSimulation.simulationSize,
    taskReferences: ((_brainSimulation$task = brainSimulation.taskReferences) == null ? void 0 : _brainSimulation$task.map(taskReferenceApiToTaskReferenceEntity)) ?? [],
    supervisorRunningStatus: brainSimulation.supervisorRunningStatus ?? {},
    simulationFinished: brainSimulation.simulationFinished ?? false,
    supervisorEvaluationJobId: brainSimulation.supervisorEvaluationJobId ?? undefined,
    executorEvaluationJobId: brainSimulation.executorEvaluationJobId ?? undefined,
    simulationPresetId: brainSimulation.simulationPresetId ?? undefined
  };
  if (isValidBrainSimulation(convertedBrainSimulation)) {
    return convertedBrainSimulation;
  }
  throw new Error('Invalid brain simulation data', {
    cause: {
      convertedBrainSimulation
    }
  });
};
const taskReferenceApiToTaskReferenceEntity = taskReference => {
  if (!taskReference) {
    return {};
  }
  return {
    taskId: taskReference.taskId,
    supervisorConversationId: taskReference.supervisorConversationId,
    executorConversationId: taskReference.executorConversationId
  };
};
//# sourceMappingURL=converters.js.map